import React from 'react';

const Header = () => {
    return (
        <nav className='header'>
            <h1>UR 4CAST</h1>
        </nav>
    );
}

export default Header;

